import React from "react";
import { s360ConfigService } from "../Services/S360Config";

const OfflineIcon = () => (
  <svg
    width="72"
    height="48"
    viewBox="0 0 72 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 18V40C6 41.125 6.875 42 8 42H30V18C30 11.375 24.625 6 18 6C11.375 6 6 11.375 6 18ZM30 48H8C3.5 48 0 44.5 0 40V18C0 8.125 8 0 18 0H54C63.875 0 72 8.125 72 18V40C72 44.5 68.375 48 64 48H36H30ZM36 18V42H64C65 42 66 41.125 66 40V18C66 11.375 60.625 6 54 6H31.375C34.25 9.25 36 13.5 36 18ZM13 16H23C24.625 16 26 17.375 26 19C26 20.75 24.625 22 23 22H13C11.25 22 10 20.75 10 19C10 17.375 11.25 16 13 16ZM45 16H55H57C58.625 16 60 17.375 60 19V25C60 26.75 58.625 28 57 28H55C53.25 28 52 26.75 52 25V22H45C43.25 22 42 20.75 42 19C42 17.375 43.25 16 45 16Z"
      fill="#758BA3"
    />
  </svg>
);

const OfflineMessage = () => {
  const businessHour = s360ConfigService?.config?.businessHour;
  const offlineConfig = businessHour?.offlineHour;
  // Prefer top-level businessHour.offlineMessage when present, else fallbacks
  const message =
    (businessHour?.offlineMessage || "").trim() ||
    (offlineConfig?.message || "").trim() ||
    "Unfortunately, all of our agents are offline right now. We'll get back to you as soon as we can.";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        padding: "32px 24px",
        textAlign: "center",
      }}
    >
      <div style={{ marginBottom: 24 }}>
        <OfflineIcon />
      </div>
      <p
        style={{
          margin: 0,
          fontSize: 14,
          lineHeight: "22px",
          color: "#3C4257",
          maxWidth: 320,
        }}
      >
        {message}
      </p>
    </div>
  );
};

export default OfflineMessage;
